import { render, staticRenderFns } from "./activityAdapterFile_enUS.vue?vue&type=template&id=b6f45358&scoped=true"
import script from "./activityAdapterFile_enUS.vue?vue&type=script&lang=js"
export * from "./activityAdapterFile_enUS.vue?vue&type=script&lang=js"
import style0 from "./activityAdapterFile_enUS.vue?vue&type=style&index=0&id=b6f45358&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f45358",
  null
  
)

export default component.exports